import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_CONFIRM_PHARMACY_ORDER } from "../../action-types/actions";

import i18n from "../../i18n";
export const confirmPharmacyOrder = createAsyncThunk(
  ACTIONS_CONFIRM_PHARMACY_ORDER.confirm_order,
  async ({ orderId, payload }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.confirmPharmacyOrder}/${orderId}/confirm`,
        payload,
      );

      if (response?.status === 200 || response?.data?.status === true) {
        toast.success(i18n.t("pharmacy.toast.orderConfirmedSuccessfully"));
        return response.data;
      } else {
        toast.error(response?.data?.message || i18n.t("pharmacy.toast.orderConfirmationFailed"));
        return rejectWithValue(response.data);
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.message ||
        i18n.t("pharmacy.toast.errorConfirmingOrder");
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
